var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoComedy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C10.1 15 11.0417 14.6083 11.825 13.825C12.6083 13.0417 13 12.1 13 11H5C5 12.1 5.39167 13.0417 6.175 13.825C6.95833 14.6083 7.9 15 9 15ZM4 7H8C8 6.45 7.80417 5.97917 7.4125 5.5875C7.02083 5.19583 6.55 5 6 5C5.45 5 4.97917 5.19583 4.5875 5.5875C4.19583 5.97917 4 6.45 4 7ZM10 7H14C14 6.45 13.8042 5.97917 13.4125 5.5875C13.0208 5.19583 12.55 5 12 5C11.45 5 10.9792 5.19583 10.5875 5.5875C10.1958 5.97917 10 6.45 10 7ZM9 20C7.75 20 6.57917 19.7625 5.4875 19.2875C4.39583 18.8125 3.44583 18.1708 2.6375 17.3625C1.82917 16.5542 1.1875 15.6042 0.7125 14.5125C0.2375 13.4208 0 12.25 0 11V0H18V11C18 12.25 17.7625 13.4208 17.2875 14.5125C16.8125 15.6042 16.1708 16.5542 15.3625 17.3625C14.5542 18.1708 13.6042 18.8125 12.5125 19.2875C11.4208 19.7625 10.25 20 9 20ZM9 18C10.9333 18 12.5833 17.3167 13.95 15.95C15.3167 14.5833 16 12.9333 16 11V2H2V11C2 12.9333 2.68333 14.5833 4.05 15.95C5.41667 17.3167 7.06667 18 9 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoComedy);
export default __webpack_public_path__ + "static/media/info_comedy.9e227f9620f0667a57f06eacf0b627d2.svg";
export { ForwardRef as ReactComponent };